<template>
  <v-app id="main-container" v-if="!loading">
     <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-item @click="$router.push('/top-clip.html')">
          <v-list-item-action>
            <font-awesome-icon icon="fire" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Top Clip</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$router.push('/broadcaster-choice')" v-if="broadcasterChoice !== null">
          <v-list-item-action>
            <font-awesome-icon icon="video" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Broadcaster Choice</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$router.push('/help')">
          <v-list-item-action>
            <font-awesome-icon icon="question" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Help</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <font-awesome-icon icon="bars" />
      </v-app-bar-nav-icon>
      <v-toolbar-title>{{ this.$router.currentRoute.name }}</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
  <v-overlay v-else >
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'app',
  data () {
    return {
      drawer: null
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'broadcasterChoice'
    ])
  },
  methods: {
    ...mapActions([
      'onAuthorized',
      'loadSettings'
    ])
  },
  mounted () {
    if (window.Twitch) {
      window.Twitch.ext.onAuthorized((auth) => {
        this.onAuthorized(auth)
      })
      window.Twitch.ext.configuration.onChanged(() => {
        this.loadSettings()
      })
      window.Twitch.ext.onContext((context) => {
        if (context.theme === 'dark') {
          this.$vuetify.theme.dark = true
        } else {
          this.$vuetify.theme.dark = false
        }
      })
    }
  }
}
</script>

<style>
html {
  overflow-y: hidden !important;
}
</style>
